import { NoTransformConfigurationError } from './transformers/NoTransformConfigurationError.mjs';

/**
 * @internal
 */
function controller(..._args) {
    NoTransformConfigurationError("llm.controller");
}
/**
 * @internal
 */
function application() {
    NoTransformConfigurationError("llm.application");
}
/**
 * @internal
 */
function parameters() {
    NoTransformConfigurationError("llm.parameters");
}
/**
 * @internal
 */
function schema() {
    NoTransformConfigurationError("llm.schema");
}

export { application, controller, parameters, schema };
//# sourceMappingURL=llm.mjs.map
